import Icon from '@mdi/react'
import type { IconProps } from '.'

const dragIndicatorSvg = `M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2m-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2`

type DragIndicatorProps = IconProps & {
    'data-testid'?: string
}

const DragIndicator = (props: DragIndicatorProps) => {
    const { color, size = 1, ...other } = props
    return <Icon path={dragIndicatorSvg} size={size} color={color} {...other} />
}

export default DragIndicator
